import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Card,
  CardContent,
  Divider,
  Grid,
  Typography,
} from '@mui/material';
import { useState } from 'react';

import { Countercards } from 'src/components/accounts-management';
import CounterWithTablesWithoutGraphs from 'src/components/accounts-management/counter-with-table-without-grapgh';
import CounterWithTables from 'src/components/accounts-management/counter-with-tables';
import HeadingCard from 'src/components/accounts-management/heading-card-dashboard';
import BalanceSheet from 'src/components/accounts-management/SideCards.js/balance-sheet';
import Iconify from 'src/components/iconify';
export default function Dashboard({ data }) {
  const [expanded, setExpanded] = useState({
    totals: true,
    accounts: true,
    balanceSheet: false,
    inventory: false,
  });

  const accountReceivable = {
    title: 'RECEIVABLE',
    upperTableData: data?.receivables || [],
    lowerTableData: (data?.receivables || []).flatMap((item) => {
      const sovData = (item.sov_follow_ups || []).map((fu) => ({
        company_name: `${fu.creator?.first_name} ${fu.creator?.last_name}` || ' ',
        date: fu.date_of_receipt || ' ',
        amount: fu.amount_received || 0,
        source: 'SOV',
      }));

      const invoiceData = (item.invoice_follow_ups || []).map((fu) => ({
        company_name: fu.bank_information?.company_name || ' ',
        date: fu.date_of_receipt || ' ',
        amount: fu.amount_received || 0,
        source: 'Invoice',
      }));

      return [...sovData, ...invoiceData];
    }),

    upperTableLabels: [
      { id: 'payment_terms', label: 'No of Days' },
      { id: 'application', label: 'No of Invoices' },
      { id: 'total_amount_paid', label: 'Amount' },
    ],

    lowerTableLabels: [
      { id: 'company_name', label: 'Company Name' },
      { id: 'date', label: 'Date' },
      { id: 'amount', label: 'Amount' },
    ],

    headerAnalytics: {
      name: 'Open Invoices',
      totalInvoices: data?.receivables?.filter((r) => r.invoice_follow_ups?.length)?.length || 0,
      amount: 0,
      colors: ['#FF5733', '#33FF57', '#3357FF'],
    },
  };
  const accountPayable = {
    title: 'PAYABLES',
    upperTableData:
      data?.payables_follow_ups?.map((item) => ({ ...item, follow_ups: [item] })) || [],
    lowerTableData: (data?.payables_follow_ups || []).map((item) => ({
      id: item.id,
      company_name: item.creator?.name || ' ',
      contracted_by_date: item.created_at,
      total: item.amount_paid,
    })),
    upperTableLabels: [
      { id: 'days_left', label: 'No of Days' },
      { id: 'invoice_number', label: 'No of Invoices' },
      { id: 'amount_paid', label: 'Amount' },
    ],
    lowerTableLabels: [
      { id: 'company_name', label: 'Company Name' },
      { id: 'contracted_by_date', label: 'Date' },
      { id: 'total', label: 'Amount' },
    ],
    headerAnalytics: {
      name: 'Open Invoices',
      totalInvoices: data?.payables_follow_ups?.length,
      amount: 0,
      colors: ['#FF5733', '#33FF57', '#3357FF'],
    },
  };

  const materials = {
    title: 'MATERIALS',
    tableData: data?.performance_materials || [],
    tableLabels: [
      { id: 'name', label: 'Name' }, 
      { id: 'created_at', label: 'Date' }, 
      { id: 'cost', label: 'cost' }, 
      { id: 'CSI_code', label: 'CSI_code' }, 
      { id: 'quantity', label: 'quantity' }, 
    ],
    headerAnalytics: {
      counter: data?.performance_materials?.length,
    },
  };

  
  const equipments = {
    title: 'EQUIPMENTS',
    tableData: data?.performance_equipmnent || [],
    tableLabels: [
      { id: 'name', label: 'Name' }, // Matches 'name' from the data
      { id: 'created_at', label: 'Date' }, // Matches 'created_at' from the data
      { id: 'CSI_code', label: 'CSI_code' }, // Custom field; compute or fetch from data
      { id: 'equipment_code', label: 'Equipment code' }, // Custom field; compute or fetch from data
      { id: 'quantity', label: 'quantity' }, // Custom field; compute or fetch from data
      { id: 'own_cost', label: 'own_cost' }, // Custom field; compute or fetch from data
      { id: 'rental_cost', label: 'rental_cost' }, // Custom field; compute or fetch from data
      { id: 'operating_cost', label: 'operating_cost' }, // Custom field; compute or fetch from data
    ],
    headerAnalytics: {
      counter: data?.performance_equipmnent?.length,
    },
  };

  const tools = {
    title: 'TOOLS',
    tableData: data?.tools || [],
    tableLabels: [
      { id: 'name', label: 'Name' }, // Matches 'name' from the data
      { id: 'created_at', label: 'Date' }, // Matches 'created_at' from the data
      { id: 'amount', label: 'amount' }, // Custom field; compute or fetch from data
      { id: 'quantity', label: 'quantity' }, // Custom field; compute or fetch from data
      { id: 'unit', label: 'unit' }, // Custom field; compute or fetch from data
      { id: 'unit_price', label: 'unit_price' }, // Custom field; compute or fetch from data
      { id: 'location', label: 'location' }, // Custom field; compute or fetch from data
      { id: 'remarks', label: 'Remarks' }, // Custom field; compute or fetch from data
    ],
    headerAnalytics: {
      counter: data?.tools?.length,
    },
  };

  const assets = {
    title: 'ASSETS',
    tableData: (data?.assets || []).map((asset) => ({
      id: asset.id,
      supplier_id: asset.supplier_id,
      performed_by_id: asset.performed_by?.id,
      name: asset.name_of_room,
      number: asset.number,
      created_at: asset.created_at,
      used: asset.parts_of_replace || ' ', // example for 'used'
      allocated_to: asset.performed_by?.name || 'Unassigned',
      status: asset.floor || 'Not specified',
    })),
    tableLabels: [
      { id: 'name', label: 'Name' },
      { id: 'number', label: 'Tag No.' },
      { id: 'created_at', label: 'Received' },
      { id: 'used', label: 'Used' },
      { id: 'allocated_to', label: 'Allocated To' },
      { id: 'status', label: 'Location' },
    ],
    headerAnalytics: {
      counter: data?.assets?.length || 0,
    },
  };

  return (
    <>
      <Box display="flex" justifyContent="start" width="100%">

      </Box>
      <Card
        sx={{
          width: '100%',
          margin: 'auto',
          mt: 4,
          p: 3,
          boxShadow: 'rgba(0, 0, 0, 0.24) 0px 3px 8px',
        }}
      >
        <CardContent>
          <HeadingCard />
          <Accordion
            expanded={expanded.totals}
            onChange={() => setExpanded({ ...expanded, totals: !expanded.totals })}
          >
            <AccordionSummary expandIcon={<Iconify icon="eva:arrow-circle-down-fill" width={24} />}>
              <Typography variant="h6">Totals</Typography>
            </AccordionSummary>
            <Divider />
            <AccordionDetails>
              <Countercards data={data} />
            </AccordionDetails>
          </Accordion>

          <Accordion
            expanded={expanded.accounts}
            onChange={() => setExpanded({ ...expanded, accounts: !expanded.accounts })}
          >
            <AccordionSummary expandIcon={<Iconify icon="eva:arrow-circle-down-fill" width={24} />}>
              <Typography variant="h6">Accounts Details</Typography>
            </AccordionSummary>
            <Divider />
            <AccordionDetails>
              <Grid
                container
                spacing={5}
                justifyContent="space-between"
                alignItems="center"
                sx={{ pl: 2 }}
              >
                <Grid item lg={6} md={4} sm={12}>
                  <CounterWithTables
                    title={accountReceivable?.title}
                    upperTableData={accountReceivable?.upperTableData}
                    lowerTableData={accountReceivable?.lowerTableData}
                    upperTableLabels={accountReceivable?.upperTableLabels}
                    lowerTableLabels={accountReceivable?.lowerTableLabels}
                    Analytics={accountReceivable?.headerAnalytics}
                  />
                </Grid>
                <Grid item lg={6} md={4} sm={12}>
                  <CounterWithTables
                    title={accountPayable?.title}
                    upperTableData={accountPayable?.upperTableData}
                    lowerTableData={accountPayable?.lowerTableData}
                    upperTableLabels={accountPayable?.upperTableLabels}
                    lowerTableLabels={accountPayable?.lowerTableLabels}
                    Analytics={accountPayable?.headerAnalytics}
                  />
                </Grid>
              </Grid>
            </AccordionDetails>
          </Accordion>

          <Accordion
            expanded={expanded.balanceSheet}
            onChange={() => setExpanded({ ...expanded, balanceSheet: !expanded.balanceSheet })}
          >
            <AccordionSummary expandIcon={<Iconify icon="eva:arrow-circle-down-fill" width={24} />}>
              <Typography variant="h6">Balance Sheet</Typography>
            </AccordionSummary>
            <Divider />
            <AccordionDetails>
              <BalanceSheet page="dashboard" />
            </AccordionDetails>
          </Accordion>
          <Accordion
            expanded={expanded.inventory}
            onChange={() => setExpanded({ ...expanded, inventory: !expanded.inventory })}
          >
            <AccordionSummary expandIcon={<Iconify icon="eva:arrow-circle-down-fill" width={24} />}>
              <Typography variant="h6">Inventory Details</Typography>
            </AccordionSummary>
            <Divider />
            <AccordionDetails>
              <Card
                sx={{
                  borderRadius: '8px',
                  boxShadow: 'rgba(0, 0, 0, 0.24) 0px 3px 8px',
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 1.5,
                  mt: 2,
                  mb: 2,
                }}
              >
                <Typography variant="h4" sx={{ pl: 3, pt: 3 }}>
                  Inventory
                </Typography>
                <Grid
                  container
                  spacing={5}
                  justifyContent="space-between"
                  alignItems="center"
                  sx={{ pl: 5, pb: 3 }}
                >
                  <Grid item lg={6} md={4} sm={12}>
                    <CounterWithTablesWithoutGraphs
                      title={materials?.title}
                      tableData={materials?.tableData}
                      tableLabels={materials?.tableLabels}
                      Analytics={materials?.headerAnalytics}
                    />
                  </Grid>
                  <Grid item lg={6} md={4} sm={12}>
                    <CounterWithTablesWithoutGraphs
                      title={equipments?.title}
                      tableData={equipments?.tableData}
                      tableLabels={equipments?.tableLabels}
                      Analytics={equipments?.headerAnalytics}
                    />
                  </Grid>
                  <Grid item lg={6} md={4} sm={12}>
                    <CounterWithTablesWithoutGraphs
                      title={tools?.title}
                      tableData={tools?.tableData}
                      tableLabels={tools?.tableLabels}
                      Analytics={tools?.headerAnalytics}
                    />
                  </Grid>
                  <Grid item lg={6} md={4} sm={12}>
                    <CounterWithTablesWithoutGraphs
                      title={assets?.title}
                      tableData={assets?.tableData}
                      tableLabels={assets?.tableLabels}
                      Analytics={assets?.headerAnalytics}
                    />
                  </Grid>
                </Grid>
              </Card>
            </AccordionDetails>
          </Accordion>
        </CardContent>
      </Card>
    </>
  );
}
